import { inB } from '../v5/beats'
import { LinkScene, MesseScene, TeamScene, WandelScene } from './scenes'

/**
 * Inhalte der Exkurse. `spots` sind die Hotspots im Büro: Position in
 * Welteinheiten (`at3`) und der Bereich von --l, in dem sie sichtbar sind.
 * Wording nah am Dashboard (Aivy® Attract, Öffentlicher Einladungslink,
 * Talentpool, Teamanalyse, Kreuzmatching).
 */
export const EXKURSE = [
  {
    id: 'wandel',
    short: '2025 vs. 2026',
    eyebrow: 'Exkurs · Anforderungen im Wandel',
    title: 'Wie sich eine Stelle verändert',
    teaser: 'Erkenne Veränderungen und plane Entwicklung.',
    Scene: WandelScene,
    spots: [{ key: 'cube', at: inB('profil', 0.08, 1), at3: [5, 4, 4.6] }],
    steps: [
      {
        title: 'Das Profil von 2025',
        text: 'So sah das Anforderungsprofil für Customer Success im Jahr 2025 aus, gemeinsam festgelegt von den Fachbereichen.'
      },
      {
        title: 'Neu eingeschätzt für 2026',
        text: 'Ein Jahr später kopierst du die Stelle und startest die Anforderungsanalyse neu. Die Fachbereiche schätzen die Rolle so ein, wie sie heute ist.'
      },
      {
        title: 'Was sich verändert hat',
        text: 'Der Vergleich zeigt, wie stark sich die Stelle bewegt hat. Problemlösefähigkeit und Offenheit für Neues sind wichtiger geworden, Merkfähigkeit weniger.'
      },
      {
        title: 'Was das für dein Team heißt',
        text: 'Gleiche bestehende Mitarbeitende mit dem neuen Profil ab. Wo Entwicklungsbedarf entsteht, bietest du gezielt Schulungen an oder klärst im Gespräch, ob die Rolle noch passt.'
      }
    ]
  },
  {
    id: 'messe',
    short: 'Messe & QR-Code',
    eyebrow: 'Exkurs · Aivy® Attract',
    title: 'Auf der Messe zum passenden Job',
    teaser: 'Talente sehen direkt am Stand, welche Stelle passt.',
    Scene: MesseScene,
    spots: [
      {
        key: 'door',
        at: inB('bewerbungen', 0.02, 0.56),
        at3: [20.2, 0.3, 1.3],
        side: 'left'
      }
    ],
    steps: [
      {
        title: 'Euer Stand auf der Messe',
        text: 'HR stellt am Stand einfach einen QR-Code auf. Wer vorbeikommt, braucht dafür weder Lebenslauf noch Termin.'
      },
      {
        title: 'Scannen und spielen',
        text: 'Talente scannen den Code und starten Aivy® Attract direkt auf dem Smartphone. Ein paar kurze Spiele, mitten im Messetrubel.'
      },
      {
        title: 'Sofort sehen, was passt',
        text: 'Danach zeigt Attract, welche eurer Stellen am besten passen, mit Passungs-Grad und dem Hinweis „Passt sehr gut“.'
      },
      {
        title: 'Weiter zur Stelle',
        text: 'Ein Tipp auf „Mehr“ führt zur passenden Stellenanzeige. So wird aus einem kurzen Halt am Stand eine Bewerbung, die passt.'
      }
    ]
  },
  {
    id: 'link',
    short: 'Talentpool',
    eyebrow: 'Exkurs · Öffentlicher Einladungslink',
    title: 'Ein Link, der deinen Talentpool füllt',
    teaser: 'Talente kommen über einen Link und bleiben für später.',
    Scene: LinkScene,
    spots: [
      {
        key: 'door',
        at: inB('bewerbungen', 0.02, 0.56),
        at3: [24.6, 0.3, 1.3]
      },
      { key: 'pool', at: inB('kreuz', 0.04, 1), at3: [11.8, 20.4, 0.4] }
    ],
    steps: [
      {
        title: 'Ein Link für alle Kanäle',
        text: 'Mit dem öffentlichen Einladungslink zum Talentpool bekommst du einen Link und einen QR-Code. Du nutzt ihn in Stellenanzeigen, Social-Media-Kampagnen, auf der Karriereseite oder auf Plakaten.'
      },
      {
        title: 'Talente kommen von selbst',
        text: 'Wer den Link öffnet, macht das Game-based Assessment, ganz ohne konkrete Bewerbung. Am Ende gibt es wie immer das persönliche Stärkenprofil.'
      },
      {
        title: 'Dein Talentpool wächst',
        text: 'Alle landen mit ihren Ergebnissen in deinem Talentpool. Im Dashboard findest du sie unter „Ohne Stellenbezug“.'
      },
      {
        title: 'Neue Stelle, passende Talente',
        text: 'Steht eine neue Stelle an, matchst du den Pool per Kreuzmatching. Die passenden Talente sind dann schon da, bevor die Anzeige online ist.'
      }
    ]
  },
  {
    id: 'team',
    short: 'Teamfit',
    eyebrow: 'Exkurs · Teamanalyse',
    title: 'Passt Lena ins Team?',
    teaser: 'Sieh, wo ein Talent dein Team ergänzt.',
    Scene: TeamScene,
    spots: [{ key: 'cs', at: inB('team', 0.3, 1), at3: [16.6, 12, 2.6] }],
    steps: [
      {
        title: 'Das Team auf einen Blick',
        text: 'Die Teamanalyse legt die Ergebnisse des Customer-Success-Teams in ein Spinnennetzdiagramm. So siehst du, welche Stärken im Team stecken.'
      },
      {
        title: 'Was fehlt uns noch?',
        text: 'Blendest du die Stellenanforderung ein, wird sichtbar, wo das Team noch nicht abdeckt, was die Rolle braucht. Hier bei Problemlösefähigkeit und Gewissenhaftigkeit.'
      },
      {
        title: 'Mit Talent vergleichen',
        text: 'Jetzt legst du Lenas Profil darüber. Sie ist genau dort stark, wo das Team noch Luft nach oben hat.'
      },
      {
        title: 'Ergänzung statt Kopie',
        text: 'Lena bringt mit, was dem Team fehlt. So entscheidest du nicht nur passend zur Stelle, sondern auch passend zum Team.'
      }
    ]
  }
]

export const EXKURS_BY_ID = Object.fromEntries(EXKURSE.map((e) => [e.id, e]))
